import { createContext, useContext } from 'react';

// Lets a component anywhere in the tree (e.g. FieldHelp, nested deep inside
// a form) open the single app-level HelpSheet to a specific article,
// instead of navigating away via <Link to="/global-manual?...">. Provided
// by App.js, which owns the HelpSheet's open/slug state.
const HelpSheetContext = createContext(null);

export function useHelpSheet() {
  return useContext(HelpSheetContext);
}

export default HelpSheetContext;
